<div class="description">
  <div class="subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_SNAPSHOT_REPORT.DESCRIPTION' | translate }}
  </div>
</div>

<form [formGroup]="createSnapshotForm" class="form">
  <glxy-alert type="info" class="alert">
    {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_SNAPSHOT_REPORT.ALERT' | translate }}
  </glxy-alert>
  <glxy-form-field class="infer-business-data--checkbox">
    <!--    <mat-checkbox formControlName="infer_business_data">-->
    <!--      {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_SNAPSHOT_REPORT.FORM.INFER_BUSINESS_DATA' | translate }}-->
    <!--      <extended>-->
    <!--        {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_SNAPSHOT_REPORT.FORM.INFER_BUSINESS_DATA_DESCRIPTION' | translate }}-->
    <!--      </extended>-->
    <!--    </mat-checkbox>-->
  </glxy-form-field>
  <div class="activation-limit">
    <div class="activation-limit--title">
      {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_SNAPSHOT_REPORT.FORM.RATE_LIMIT.TITLE' | translate }}
    </div>
    <div>{{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_SNAPSHOT_REPORT.FORM.RATE_LIMIT.DESCRIPTION' | translate }}</div>
    <div>
      <glxy-form-field class="activation-limit--input" bottomSpacing="none" [showLabel]="false">
        <input type="number" formControlName="frequency" min="1" max="500" matInput />
      </glxy-form-field>
      {{ 'AUTOMATIONS.EDITOR.TASKS.RATE_FILTER.PREPROCESSOR.TIMES_WITHIN' | translate }}
    </div>
    <mat-error *ngIf="createSnapshotForm.controls.frequency.hasError('pattern')">
      {{ 'AUTOMATIONS.EDITOR.TASKS.RATE_FILTER.PREPROCESSOR.OUT_OF_BOUNDS' | translate }}
    </mat-error>
    <div>
      <glxy-form-field class="activation-limit--input" bottomSpacing="none" [showLabel]="false">
        <input type="number" formControlName="length" min="1" max="100" matInput />
      </glxy-form-field>
      <glxy-form-field class="activation-limit--select" bottomSpacing="none" [showLabel]="false">
        <mat-select formControlName="period">
          <mat-option [value]="periodHours">
            {{ 'AUTOMATIONS.EDITOR.TASKS.RATE_FILTER.ACTIVITY.HOURS' | translate }}
          </mat-option>
          <mat-option [value]="periodDays">
            {{ 'AUTOMATIONS.EDITOR.TASKS.RATE_FILTER.ACTIVITY.DAYS' | translate }}
          </mat-option>
        </mat-select>
      </glxy-form-field>
    </div>
    <mat-error *ngIf="createSnapshotForm.controls.length.hasError('pattern')">
      {{ 'AUTOMATIONS.EDITOR.TASKS.RATE_FILTER.OUT_OF_BOUNDS' | translate }}
    </mat-error>
    <mat-error *ngIf="createSnapshotForm.controls.period.hasError('invalid')">
      {{ 'AUTOMATIONS.EDITOR.TASKS.RATE_FILTER.PERIOD_INVALID' | translate }}
    </mat-error>
  </div>
</form>
